import React from 'react';

const TopRated = ({
  color = 'var(--color-primary)',
  width = 21,
  height = 19,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 19"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M690.5 1108.617L684.916 1111.186 685.633 1105.081 681.465 1100.564 687.492 1099.36 690.5 1094 693.508 1099.36 699.535 1100.564 695.367 1105.081 696.084 1111.186z"
      transform="translate(-680 -1093)"
    />
  </svg>
);

export default TopRated;
